export var InstagramPermissionErroEnum;
(function (InstagramPermissionErroEnum) {
    InstagramPermissionErroEnum["PAGES_MESSAGING"] = "pages_messaging";
    InstagramPermissionErroEnum["PAGES_MANAGE_METADATA"] = "pages_manage_metadata";
    InstagramPermissionErroEnum["PAGES_SHOW_LIST"] = "pages_show_list";
    InstagramPermissionErroEnum["INSTAGRAM_BASIC"] = "instagram_basic";
    InstagramPermissionErroEnum["INSTAGRAM_MANAGE_MESSAGES"] = "instagram_manage_messages";
    InstagramPermissionErroEnum["PAGES_READ_ENGAGEMENT"] = "pages_read_engagement";
})(InstagramPermissionErroEnum || (InstagramPermissionErroEnum = {}));
